// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"535":"2775db67","948":"8c161219"}[chunkId] + ".chunk.js";
};